import { render, staticRenderFns } from "./EudoxusExchangeComponent.vue?vue&type=template&id=36203531&scoped=true&"
import script from "./EudoxusExchangeComponent.vue?vue&type=script&lang=js&"
export * from "./EudoxusExchangeComponent.vue?vue&type=script&lang=js&"
import style0 from "./EudoxusExchangeComponent.vue?vue&type=style&index=0&id=36203531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36203531",
  null
  
)

component.options.__file = "EudoxusExchangeComponent.vue"
export default component.exports